export { default } from "./boolean-details-field";
